import { Injectable } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ActionSheetService {
  generalActionSheet: HTMLIonActionSheetElement;
  constructor(private translate: TranslateService, private actionSheetController: ActionSheetController) { }
  async selectType(list,header) {
    let buttons: Array<any> = [];
    list.forEach(element => {
      let data = {
        text: element.value,
        role: element.role,
        color: "primary",
        handler: () => {
          this.generalActionSheet.dismiss(element.id, element.role)
        }
      }
      buttons.push(data);
    });
    // [{
    this.generalActionSheet = await this.actionSheetController.create({
      header: header,
      cssClass: 'sheet-class',
      mode: "md",
      buttons: buttons
    });
    await this.generalActionSheet.present();
  }




}
